import { Dialog, DialogContent, DialogTitle, Icon } from '@mui/material';
import React from 'react'

interface messageDialogProps {
  icon?: React.ReactNode;
  userStateDilaogDilaog:{open:boolean, message:string}
  setUserStateDilaogDilaog:(userStateDilaogDilaog:{open:boolean, message:string})=>void
}

const UserStateDilaog = ({icon, userStateDilaogDilaog, setUserStateDilaogDilaog}:messageDialogProps) => {
  return (
    <Dialog 
        open={userStateDilaogDilaog.open}
        onClose={() => setUserStateDilaogDilaog({ open: false, message: "" })}
        maxWidth="xs"
    >
      <div className='flex justify-center mt-4'>
        {icon}
      </div>
      <DialogTitle style={{ wordBreak: 'break-word'}}>
          {userStateDilaogDilaog.message}
      </DialogTitle>
    </Dialog>
  )
}

export default UserStateDilaog